<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'COUNTRIES_SELECT.COUNTRY' | translate }}
    </span>

    <span *ngIf="parentFormGroup.get('country_id').value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>
  <!--<select class="form-control" formControlName="country_id">-->
  <!--<option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>-->
  <!--</select>-->
  <ng-select
    (change)="onChange($event)"
    [items]="data"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'country_id'"
    appendTo="body"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'COUNTRIES_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
</div>
